<div class="content-wrapper">

  @if ((playlistsLoading$ | async)) {
    <tun-loader-v5 class="loader"></tun-loader-v5>
  }

  @if ((playlistsLoadingError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }

  @if (!(playlistsLoading$ | async) && !(playlistsLoadingError$ | async)) {
    <div class="scrollContainer">
      <div class="smallSpacer"></div>
      @if (showQueueButton) {
        <tun-overlay-playlist-button-view
          class="playlist"
          [title]="'player.origin.queue' | translate"
          isQueue="true"
          (select)="onSelectQueue()"
          >
        </tun-overlay-playlist-button-view>
      }
      @if (favoriteList$ | async) {
        <tun-overlay-playlist-button-view
          class="playlist"
          [title]="(favoriteList$ | async).title"
          isFavorite="true"
          (select)="onSelectFavoriteList()"
          >
        </tun-overlay-playlist-button-view>
      }
      @for (playlist of (playlists$ | async); track playlist; let i = $index) {
        <tun-overlay-playlist-button-view
          class="playlist {{ (i == 0 && (favoriteList$ | async) == null) ? 'first' : ''}}"
          [title]="playlist.title"
          (select)="onSelectPlaylist(playlist)"
          >
        </tun-overlay-playlist-button-view>
      }
      <div
        class="create-button"
        (click)="onCreatePlaylist()"
        >
        <div class="create-button-start">
          <div class="create-icon-container">
            <tun-plus-icon-v5 class="icon icon-create-button"></tun-plus-icon-v5>
          </div>
          {{'playlist.addTrack.popup.button.create' | translate}}
        </div>
      </div>
    </div>
    <div class="spacer"></div>
  }
</div>
